import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import * as requests from '../api/requests';

import { addNotification, addErrorNotification } from './notificationsSlice';

const initialState = {};

export const handleSignUp = createAsyncThunk(
  'signUp/handleSignUp',
  async(args, thunkAPI) => {
    const { email, password, confirmPassword } = args;
    const res = await requests.handleSignUp(email, password, confirmPassword);
    const { ok } = res;
    const body = await res.json();

    if (ok) {
      thunkAPI.dispatch(addNotification('Verification code sent to your email!'));
    } else {
      const errmsg = body.errmsg || 'Something Went Wrong When Creating The Account!';
      thunkAPI.dispatch(addErrorNotification(errmsg));
    }

    return { ok, body };
  }
);

export const handleVerifyEmail = createAsyncThunk(
  'signUp/handleVerifyEmail',
  async(args, thunkAPI) => {
    const { email, code } = args;
    const res = await requests.verifyEmail(email, code);
    const body = await res.json();
    
    if (res.ok) {
      thunkAPI.dispatch(addNotification('Email verified! Redirecting to login...'));
      return { ok: true, body };
    } else {
      const errmsg = body.errmsg || 'Verification failed';
      thunkAPI.dispatch(addErrorNotification(errmsg));
      return { ok: false, body };
    }
  }
);

export const handleResendCode = createAsyncThunk(
  'signUp/handleResendCode',
  async(args, thunkAPI) => {
    const { email } = args;
    const res = await requests.resendVerificationCode(email);
    const body = await res.json();
    
    if (res.ok) {
      thunkAPI.dispatch(addNotification('Verification code resent to your email!'));
      return { ok: true, body };
    } else {
      const errmsg = body.errmsg || 'Failed to resend code';
      thunkAPI.dispatch(addErrorNotification(errmsg));
      return { ok: false, body };
    }
  }
);

export const signUpSlice = createSlice({
  name: 'signUp',
  initialState
});

export default signUpSlice.reducer;
